import React, { useState } from 'react';
import { Layout } from 'tea-component';
import { connect, useIntl } from 'umi';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import ContentBody from '@op/components/ContentBody';
import CardLoading from '@op/components/CardLoading';
import MentionsSentiment from './MentionsSentiment';
import GameStore from './GameStore';
import Community from './Community';
import PR from './PR';
import GoogleTrends from './GoogleTrends';
import { PAGE_NAME } from '@op/constants/page';
import { arrayToObj, scrollToAnchorPoint } from '@op/utils';
import { baseColors, extendColors } from '@op/constants';
import Navigator, { useNavigatorScroll } from '@op/components/Navigator';
import { getCompareKeyMetricsNavigatorOptions } from './constants';
import './index.scss';
import {
  buriedBtnPoint,
  useInitBuriedPointInfo,
} from '@op/operationLog/buriedPoint';
import compareKeyMetrics from '@op/operationLog/pages/compareKeyMetrics';
const { Content } = Layout;

const defaultColorArr = [...baseColors, ...extendColors];

function CompareKeyMetrics({ gameInfo, wholeGameInfo }: any) {
  const { formatMessage } = useIntl();
  const [competitorGames, setCompetitorGames] = useState({});
  const { loading, filter, changeFilter, filterOptions } = useFilterDataHook({
    gameInfo,
    pageName: 'Compare_Key_Metrics',
  });
  useInitBuriedPointInfo({ buriedPoint: compareKeyMetrics });
  const options = getCompareKeyMetricsNavigatorOptions(
    gameInfo.entity_type,
    formatMessage,
  );

  const { selectNavigator, setSelectNavigator, handleScroll, scrollBody } =
    useNavigatorScroll({
      allKeys: options.map((item) => item.value),
      defaultValue: 'Mentions & Sentiment',
      debounceTime: 10,
    });

  return (
    <Content
      className="dbo-page dbo-page-metrics"
      ref={scrollBody}
      onScrollCapture={handleScroll}
    >
      <ContentBody
        pageName={PAGE_NAME.COMPARE_KEY_METRICS}
        contentHeard={
          <Content.Header
            className="dbo-header"
            title={formatMessage({ id: PAGE_NAME.COMPARE_KEY_METRICS })}
          ></Content.Header>
        }
      >
        <FilterFixed
          filter={filterOptions}
          backCondOriginData={(data) => {
            const { competitor_games } = data || {};
            const localGameList = competitor_games.map(
              (item: any, index: number) => ({
                ...item,
                color: defaultColorArr[index + 1],
                index: index + 1,
              }),
            );
            localGameList.unshift({
              ...wholeGameInfo,
              color: defaultColorArr[0],
              index: 0,
            });

            setCompetitorGames(arrayToObj(localGameList, 'edition_unified_id'));
          }}
          confirm={(value: any) => {
            changeFilter({
              ...value,
              ...gameInfo,
              games: [
                ...(value.games || []),
                { ...gameInfo, release_time: wholeGameInfo.release_time },
              ],
            });
          }}
        ></FilterFixed>

        <CardLoading loading={loading}>
          <Navigator
            scrollBody={scrollBody}
            options={options}
            onChange={(curNavigator: any) => {
              setSelectNavigator(curNavigator);
              scrollToAnchorPoint(curNavigator, 'start');
              buriedBtnPoint('CKMS_Location', curNavigator);
            }}
            value={selectNavigator}
            setValue={setSelectNavigator}
          ></Navigator>
          <MentionsSentiment
            filter={filter}
            gameData={competitorGames}
            wholeGameInfo={wholeGameInfo}
          ></MentionsSentiment>
          <GameStore
            filter={filter}
            gameInfo={gameInfo}
            gameData={competitorGames}
            wholeGameInfo={wholeGameInfo}
          ></GameStore>
          <Community
            filter={filter}
            gameData={competitorGames}
            gameInfo={gameInfo}
          ></Community>
          <PR
            gameData={competitorGames}
            filter={filter}
            wholeGameInfo={wholeGameInfo}
          ></PR>
          <GoogleTrends
            gameData={competitorGames}
            filter={filter}
            wholeGameInfo={wholeGameInfo}
          ></GoogleTrends>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon, opinionFilter } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    filter: opinionFilter,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(CompareKeyMetrics);
